// Import FirebaseAuth and firebase.
import React, { useState } from 'react';
// import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import firebase from 'firebase/app';
import { Button, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useRouter } from 'next/router';

export default function AdminLogin({ url }: { url: string }): JSX.Element {
  const { replace } = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  const loginAdmin = async () => {
    const userCredentials = await firebase.auth().signInWithEmailAndPassword(email, password);
    if (userCredentials.user) {
      replace(url);
    }
  };

  return (
    <div>
      <Input
        pr="4.5rem"
        placeholder="Enter email"
        onChange={({ target: { value } }) => setEmail(value)}
        value={email}
      />
      <InputGroup size="md">
        <Input
          onChange={({ target: { value } }) => setPassword(value)}
          value={password}
          pr="4.5rem"
          type={show ? 'text' : 'password'}
          placeholder="Enter password"
        />
        <InputRightElement width="4.5rem">
          <Button h="1.75rem" size="sm" onClick={handleClick}>
            {show ? 'Hide' : 'Show'}
          </Button>
        </InputRightElement>
      </InputGroup>
      <Button onClick={() => loginAdmin()}>Login</Button>
    </div>
  );
}
